import { BrowserRouter, BrowserRouterProps } from 'react-router-dom';

export const CustomBrowserRouter = ({ children }: BrowserRouterProps) => {
  const TR_URL = window.location.pathname;
  return <BrowserRouter basename={TR_URL}>{children}</BrowserRouter>;
};
